
/*export const domain = 'https://localhost:44393/';*/
export const domain = '/';
export const domainDebug = 'https://localhost:44393/';
export const domainImage = domain+ 'uploads';
export const domainImageFile = domain+ 'uploads/';
export const domainMedia = domain + 'uploads';
export const domainFile = domain + 'uploads/files';
export const domainVideos = domain + 'uploads/videos/';

export const navItems = [
	{
		name: 'Trang tổng quan',
		url: '/dashboard',
		icon: 'icon-home'
	}
];

export const typeCategoryNews = [
  {
	  Id: 1,
	  Name: 'Tin viết',
      ConstUrl: 'xem-truoc-tin-van-ban'
  },
  {
    Id: 9,
    Name: 'Bài viết',
    ConstUrl: 'xem-truoc-tin-bai-viet'
  },
	{
		Id: 2,
		Name: 'Thông tin có sẵn',
		ConstUrl: 'chi-tiet-thong-bao'
	},
	{
		Id: 3,
		Name: 'Hình ảnh',
    ConstUrl: 'xem-truoc-tin-hinh-anh'
	},
	{
		Id: 4,
		Name: 'Video',
    ConstUrl: 'xem-truoc-tin-video'
  },
  {
    Id: 8,
    Name: 'Văn bản',
    ConstUrl: 'chi-tiet-giai-phap'
  },
	// {
	// 	Id: 5,
	// 	Name: 'Tin đính kèm'
	// },
  //{
  //  Id: 7,
  //  Name: 'Tin sự kiện',
  //  ConstUrl: 'xem-truoc-tin-su-kien'
  //},
  //{
  //  Id: 8,
  //  Name: 'Tin Emagazine',
  //  ConstUrl: 'xem-truoc-tin-emagazine'
  //},
  
]

export const typeCategoryPage = [
	{
		Id: 6,
		Name: 'Trang bình thường',
		Group: 'Trang bình thường'
	},
	{
		Id: 7,
		Name: 'Dofollow',
		Group: 'Liên kết trên trang'
	},
	{
		Id: 8,
		Name: 'Dofollow',
		Group: 'Liên kết ngoài trang'
	},
	{
		Id: 9,
		Name: 'Nofollow',
		Group: 'Liên kết trên trang'
	},
	{
		Id: 10,
		Name: 'Nofollow',
		Group: 'Liên kết ngoài trang'
	}
];

export const Language = [
	{
		Id: 1,
		Name: 'Tiếng Việt'
	},
	{
		Id: 7,
		Name: 'Tiếng Anh'
	}
];

export const Paging = {
	page: 1,
	page_size: 10,
	query: '1=1',
	order_by: '',
	item_count: 0
};

export const Filter = {
	txtSearch: ''
}

export const typeSlide = [
	{
		Id: 1,
		Name: 'loại 1'
	},
	{
		Id: 2,
		Name: 'loại 2'
	},
	{
		Id: 3,
		Name: 'loại 3'
	},
	{
		Id: 4,
		Name: 'loại 4'
	}
]

export const typeRank = [
	{
		Id: 1,
		Name: 'Diện tích'
	},
	{
		Id: 2,
		Name: 'Đơn giá'
	}
]

export const typeProduct = [
  {
    Id: 1,
    Name: 'Sản phẩm đơn giản'
  },
  {
    Id: 2,
    Name: 'Sản phẩm có biến thể'
  }
]

export const TypeUpload = [
	{
		Id: 1,
		Name: 'Tin tức'
	},
	{
		Id: 2,
		Name: 'Sản phẩm'
	},
	{
		Id: 3,
		Name: 'Slide'
	},
	{
		Id: 4,
		Name: 'Icon'
	},
	{
		Id: 5,
		Name: 'Danh mục'
	},
	{
		Id: 6,
		Name: 'Loại khác'
	}
]

export const OrderStatus = [
	{
		Id: 1,
		Name: 'Khởi tạo',
		Class: 'badge badge-primary'
	},
	{
		Id: 2,
		Name: 'Đã xác nhận',
		Class: 'badge badge-info'
	},
	{
		Id: 3,
		Name: 'Đang giao hàng',
		Class: 'badge badge-light'
	},
	{
		Id: 4,
		Name: 'Đã giao hàng',
		Class: 'badge badge-warning'
	},
	{
		Id: 5,
		Name: 'Bị hủy',
		Class: 'badge badge-danger'
	}
]

export const TypeContact = [
	//{
	//	Id: 1,
	//	Name: 'Liên hệ'
	//},
	//{
	//	Id: 2,
	//	Name: 'Đăng ký nhận tin'
	//},
	//{
	//	Id: 3,
	//	Name: 'Đặt lịch và báo giá'
 // },
 // {
 //   Id: 10,
 //   Name: 'Ứng tuyển'
 // },
 // {
 //   Id: 11,
 //   Name: 'Đăng ký tư vấn'
 // }
 // {
 //   Id: 12,
 //   Name: 'Khác'
 // },
  {
    Id: 13,
    Name: 'Liên hệ'
  },
  {
    Id: 1,
    Name: 'Khác'
  }
]

export const TypeUser = [
  {
    Id: 1,
    Name: 'Xác nhận'
  },
  {
    Id: 2,
    Name: 'Chưa xác nhận'
  }
]

export const TypeUserSy = [
  {
    Id: 1,
    Name: 'Hoạt động'
  },
  {
    Id: 98,
    Name: 'Khóa'
  }
]


export const ProductReviewStatus = [
	{
		Id: 1,
		Name: 'Khởi tạo'
	},
	{
		Id: 2,
		Name: 'Đã được duyệt'
	},
	{
		Id: 3,
		Name: 'Không được duyệt'
	}
]

export const PaymentOrderStatus = [
	{
		Id: 1,
		Name: 'Chưa thanh toán',
		Class: 'badge badge-primary'
	},
	{
		Id: 2,
		Name: 'Đã thanh toán hết',
		Class: 'badge badge-info'
	},
	{
		Id: 3,
		Name: 'Chưa thanh toán hết',
		Class: 'badge badge-light'
	},
	{
		Id: 4,
		Name: 'Không thanh toán',
		Class: 'badge badge-warning'
	},
	{
		Id: 5,
		Name: 'Thanh toán lỗi',
		Class: 'badge badge-danger'
	}
]

export const ActionTable = [
	{
		Id: 1,
		Name: 'Xóa đã chọn'
	}
]

export const Status = [
	{
		Id: 1,
		Name: 'Xuất bản'
	},
	{
		Id: 11,
		Name: 'Chờ duyệt'
  },
  {
    Id: 12,
    Name: 'Đã duyệt'
  },
  {
    Id: 13,
    Name: 'Bài Nháp'
  },
  {
    Id: 98,
    Name: 'Riêng tư'
  }
]

export const NewsStatus = [
  {
    Id: 1,
    Name: 'Xuất bản'
  },
  {
    Id: 10,
    Name: 'Bài viết nháp'
  },
  {
    Id: 11,
    Name: 'Bài viết mới'
  },
  {
    Id: 12,
    Name: 'Bài viết trả lại'
  },
  {
    Id: 13,
    Name: 'Chờ biên tập'
  },
  {
    Id: 14,
    Name: 'Đã biên tập'
  },
  {
    Id: 15,
    Name: 'Biên tập lại'
  },
  {
    Id: 16,
    Name: 'Chờ duyệt'
  },
  {
    Id: 17,
    Name: 'Không duyệt'
  },
  {
    Id: 18,
    Name: 'Chờ xuất bản'
  },
  {
    Id: 19,
    Name: 'Gỡ xuất bản'
  }
]

export const listHotNews = [
  {
    Id: true,
    Name: 'Tin Nóng'
  },
  {
    Id: false,
    Name: 'Tin Thường'
  },
]

export const listCashNews = [
  {
    Id: 1,
    Name: 'Tất cả'
  },
  {
    Id: 2,
    Name: 'Chưa có nhuận bút'
  },
  {
    Id: 3,
    Name: 'Đã có nhuận bút'
  },
]

export const listTypeAuthor = [
  {
    Id: 1,
    Name: 'Tác giả tin tức'
  },
  {
    Id: 2,
    Name: 'Tác giả ấn phẩm'
  }
]
export const listTemplate = [
  {
    Id: 1,
    Name: 'Mặc định'
  },
  {
    Id: 2,
    Name: 'Danh mục cha'
  },
  {
    Id: 3,
    Name: 'Hình ảnh'
  },
  {
    Id: 4,
    Name: 'Video'
  }
]
export const listTypeMedia = [
  {
    Id: 1,
    Name: 'Hình ảnh'
  },
  {
    Id: 2,
    Name: 'Audio'
  },
  {
    Id: 3,
    Name: 'Video'
  },
  {
    Id: 4,
    Name: 'Tài liệu'
  },
  {
    Id: 5,
    Name: 'Khác'
  }
]
export const listTypeToChuc = [
  {
    Id: 1,
    Name: 'TCTC vi mô'
  },
  {
    Id: 2,
    Name: 'Quỹ tín dụng nhân dân'
  },
  {
    Id: 3,
    Name: 'NHTM nhà nước'
  },
  {
    Id: 4,
    Name: 'NHTM cổ phần'
  },
  {
    Id: 5,
    Name: 'NH liên doanh'
  },
  {
    Id: 6,
    Name: 'NH hợp tác'
  },
  {
    Id: 7,
    Name: 'NH 100% vốn nước ngoài'
  },
  {
    Id: 8,
    Name: 'Chi nhánh NH nước ngoài'
  }
]
